import { SalesOrderStatus } from '../../constants/sales-order-status.js';
/** A Credit Return reaches Delivered only once Receiving has the goods back; Shipped means it is still on its way. */
export const RECEIVED_CREDIT_RETURN_SALES_ORDER_STATUS_IDS = new Set([
    SalesOrderStatus.DELIVERED,
    SalesOrderStatus.COMPLETE,
]);
//# sourceMappingURL=received-credit-return-sales-order-status-ids.js.map